/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetOccupationQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetOccupationQuery = { __typename?: 'Query', surveyOccupation: { __typename?: 'Occupation', id: string, annualIncomeBeforeCompany: number | null, atLeast30HoursAWeek: boolean | null, becameOwnerAt: string | null, companyFoundedAt: string | null, corporateStructure: string | null, disabilityInsuranceSource: string | null, disabilityInsuranceStatus: boolean | null, educationLevel: string | null, employerPaysPremium: boolean | null, existingCoverage: number | null, governmentEmployee: boolean | null, individualIncome: number | null, intendToReplace: boolean | null, numberOfEmployees: number | null, numberOfPartners: number | null, ownershipStake: number | null, selfEmployed: boolean | null, workFromHomePercentage: number | null, yearsOfExperience: number | null, job: { __typename?: 'Job', id: string, title: string, group: string } | null } };


export const GetOccupationDocument = gql`
    query GetOccupation {
  surveyOccupation {
    id
    annualIncomeBeforeCompany
    atLeast30HoursAWeek
    becameOwnerAt
    companyFoundedAt
    corporateStructure
    disabilityInsuranceSource
    disabilityInsuranceStatus
    educationLevel
    employerPaysPremium
    existingCoverage
    governmentEmployee
    individualIncome
    intendToReplace
    job {
      id
      title
      group
    }
    numberOfEmployees
    numberOfPartners
    ownershipStake
    selfEmployed
    workFromHomePercentage
    yearsOfExperience
  }
}
    `;
export function useGetOccupationQuery(baseOptions?: Apollo.QueryHookOptions<GetOccupationQuery, GetOccupationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOccupationQuery, GetOccupationQueryVariables>(GetOccupationDocument, options);
      }
export function useGetOccupationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOccupationQuery, GetOccupationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOccupationQuery, GetOccupationQueryVariables>(GetOccupationDocument, options);
        }
export type GetOccupationQueryHookResult = ReturnType<typeof useGetOccupationQuery>;
export type GetOccupationLazyQueryHookResult = ReturnType<typeof useGetOccupationLazyQuery>;
export type GetOccupationQueryResult = Apollo.QueryResult<GetOccupationQuery, GetOccupationQueryVariables>;